import React from "react";

const RequiredField = ({ color }) => {
  return <span style={{ color }}>*</span>;
};
export default RequiredField;
